import React from "react";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";

interface ActivateConfirmationPopupProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ActivateConfirmationPopup: React.FC<ActivateConfirmationPopupProps> = ({
    visible, onConfirm, onCancel,
}) => {
    return (
        <ConfirmationPopup
            visible={visible}
            onCancel={onCancel}
            onConfirm={onConfirm}
            message="Are you sure you want to activate this item?"
            confirmButtonText="Activate"
            variant="submit"
        />
    );
};

export default ActivateConfirmationPopup;
